/* ONX homepage carousel: scroll-snap track with pagination bars, prev/next buttons and the second image
   on hover for .onx-pc cards. Loaded on the homepage only, by the sections that use it.
   Markup contract (see sections/onx-home-best-sellers.liquid):
     [data-onx-carousel]  root, optional data-bars-desktop / data-bars-mobile (max bars, default 3 / 5)
       [data-onx-track]   the scrolling list, its children are the items
       [data-onx-bars]    empty container for the pagination bars
       [data-onx-prev] [data-onx-next]  buttons */
(function () {
  'use strict';
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.__onxCarousel) return;
    root.__onxCarousel = true;
    var track = root.querySelector('[data-onx-track]');
    var barsEl = root.querySelector('[data-onx-bars]');
    var prev = root.querySelector('[data-onx-prev]');
    var next = root.querySelector('[data-onx-next]');
    if (!track) return;
    var barCount = 0;

    function items() { return Array.prototype.slice.call(track.children); }
    function step() {
      var list = items();
      if (list.length < 2) return list.length ? list[0].getBoundingClientRect().width : 0;
      return list[1].offsetLeft - list[0].offsetLeft;
    }
    function perView() {
      var s = step();
      if (!s) return 1;
      var pad = parseFloat(getComputedStyle(track).paddingRight) || 0;
      return Math.max(1, Math.floor((track.clientWidth - pad + 8) / s));
    }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }

    function buildBars() {
      if (!barsEl) return;
      var pages = Math.max(1, Math.ceil(items().length / perView()));
      var cap = mqMobile.matches ? (parseInt(root.getAttribute('data-bars-mobile'), 10) || 5) : (parseInt(root.getAttribute('data-bars-desktop'), 10) || 3);
      var n = maxScroll() <= 2 ? 1 : Math.min(pages, cap);
      if (n === barCount) return;
      barCount = n;
      barsEl.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('span');
        b.className = 'onx-ctl__bar';
        barsEl.appendChild(b);
      }
      barsEl.hidden = n < 2;
    }

    function update() {
      buildBars();
      var max = maxScroll();
      var x = track.scrollLeft;
      if (barsEl && barCount) {
        var idx = max ? Math.round((x / max) * (barCount - 1)) : 0;
        var kids = barsEl.children;
        for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-active', i === idx);
      }
      if (prev) prev.setAttribute('aria-disabled', x <= 2 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', x >= max - 2 ? 'true' : 'false');
    }

    function go(dir) {
      var amount = perView() * step();
      track.scrollBy({ left: dir * amount, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') go(-1); });
    if (next) next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') go(1); });

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
  }

  /* Second product image on hover: fetched the first time a mouse pointer enters the card. */
  function armHover(card) {
    var src = card.getAttribute('data-hover-src');
    if (!src || card.classList.contains('is-hover-ready') || card.__onxHover) return;
    card.__onxHover = true;
    var media = card.querySelector('.onx-pc__media');
    if (!media) return;
    var img = new Image();
    img.className = 'onx-pc__img onx-pc__img--hover';
    img.alt = '';
    img.decoding = 'async';
    img.width = 410;
    img.height = 400;
    var srcset = card.getAttribute('data-hover-srcset');
    var main = card.querySelector('.onx-pc__img');
    if (srcset) { img.srcset = srcset; img.sizes = main ? main.sizes : '410px'; }
    img.onload = function () { card.classList.add('is-hover-ready'); };
    img.src = src;
    media.insertBefore(img, media.firstChild.nextSibling);
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var card = e.target.closest ? e.target.closest('.onx-pc[data-hover-src]') : null;
    if (card) armHover(card);
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest ? e.target.closest('.onx-pc[data-hover-src]') : null;
    if (card) armHover(card);
  });

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-onx-carousel]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
